
const selected = document.querySelector(".selected");
const optionsContainer = document.querySelector(".options-container");
const optionsList = document.querySelectorAll(".option");
selected.addEventListener("click", () => {
  optionsContainer.classList.toggle("active");
});
optionsList.forEach(o => {
  o.addEventListener("click", () => {
    selected.innerHTML = o.querySelector("label").innerHTML;
    optionsContainer.classList.remove("active");
  });
});
function myFunction() {
  let xDate = document.querySelector('input[type="date"]');
  let endDate = xDate.value;
  let date1 = new Date();
  let date2 = new Date(endDate);
  let timeInMilisec = date2.getTime() - date1.getTime() ;
  let remainingDays = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24)+1);
  const country = selected.innerText;
    if (country == 'All Arab Countries') {
      let basePrice = 50;
      let extra = 83;
      let premium = 96;
      let qbasePrice = 21;
      let qExtra = 34;
      let qPremium = 40;
      let fromBaseToExtra = remainingDays*(extra-basePrice)/365;
      let fromBaseToExtraR = fromBaseToExtra.toFixed(2);
      let fromBaseToPremium = remainingDays*(premium-basePrice)/365;
      let fromBaseToPremiumR = fromBaseToPremium.toFixed(2);
      let fromQBaseToExtra = remainingDays*(qExtra-qbasePrice)/365;
      let fromQBaseToExtraR = fromQBaseToExtra.toFixed(2);
      let fromQBaseToPremium = remainingDays*(qPremium-qbasePrice)/365;
      let fromQBaseToPremiumR = fromQBaseToPremium.toFixed(2);
      if (remainingDays > 90) {
        document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
        <h3>Thanks for using Our PS Plus Calc.</h3><br>
        You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
          <center>
          <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}$</strong><br>
          <strong>👉Upgrade to Deluxe:</strong> You will pay <strong>${fromBaseToPremiumR}$</strong>
          </center>
        <br>`;
      } else {
        document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
        <h3>Thanks for using Our PS Plus Calc.</h3><br>
        You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
          <center>
          <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}$</strong><br>
          <strong>👉Upgrade to Deluxe:</strong> You will pay <strong>${fromBaseToPremiumR}$</strong>
          </center>
        <br>
        If you're on the 3 Month Essentials plan and want to
          <center>
          <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromQBaseToExtraR}$</strong><br>
          <strong>👉Upgrade to Deluxe:</strong> You will pay <strong>${fromQBaseToPremiumR}$</strong>
          </center>
        <strong>Please Note that</strong> sales tax isn't included, It depends on your state.</div>`;
      }
    } else if (country == 'United States') { 
    let basePrice = 60;
    let extra = 100;
    let premium = 120;
    let qbasePrice = 25;
    let qExtra = 40;
    let qPremium = 50;
    let fromBaseToExtra = remainingDays*(extra-basePrice)/365;
    let fromBaseToExtraR = fromBaseToExtra.toFixed(2);
    let fromBaseToPremium = remainingDays*(premium-basePrice)/365;
    let fromBaseToPremiumR = fromBaseToPremium.toFixed(2);
    let fromQBaseToExtra = remainingDays*(qExtra-qbasePrice)/365;
    let fromQBaseToExtraR = fromQBaseToExtra.toFixed(2);
    let fromQBaseToPremium = remainingDays*(qPremium-qbasePrice)/365;
    let fromQBaseToPremiumR = fromQBaseToPremium.toFixed(2);
    if (remainingDays > 90) {
      document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
      <h3>Thanks for using Our PS Plus Calc.</h3><br>
      You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
        <center>
        <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}$</strong><br>
        <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromBaseToPremiumR}$</strong>
        </center>
      <br>`;
    } else {
      document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
      <h3>Thanks for using Our PS Plus Calc.</h3><br>
      You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
        <center>
        <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}$</strong><br>
        <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromBaseToPremiumR}$</strong>
        </center>
      <br>
      If you're on the 3 Month Essentials plan and want to
        <center>
        <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromQBaseToExtraR}$</strong><br>
        <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromQBaseToPremiumR}$</strong>
        </center>
      <strong>Please Note that</strong> sales tax isn't included, It depends on your state.</div>`;
    }
    } else if (country == 'United Kingdom') { 
      let basePrice = 50;
      let extra = 84;
      let premium = 100;
      let qbasePrice = 20;
      let qExtra = 32;
      let qPremium = 40;
      let fromBaseToExtra = remainingDays*(extra-basePrice)/365;
      let fromBaseToExtraR = fromBaseToExtra.toFixed(2);
      let fromBaseToPremium = remainingDays*(premium-basePrice)/365;
      let fromBaseToPremiumR = fromBaseToPremium.toFixed(2);
      let fromQBaseToExtra = remainingDays*(qExtra-qbasePrice)/365;
      let fromQBaseToExtraR = fromQBaseToExtra.toFixed(2);
      let fromQBaseToPremium = remainingDays*(qPremium-qbasePrice)/365;
      let fromQBaseToPremiumR = fromQBaseToPremium.toFixed(2);
      
        if (remainingDays > 90) {
          document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
          <h3>Thanks for using Our PS Plus Calc.</h3><br>
          You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
            <center>
            <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}£</strong><br>
            <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromBaseToPremiumR}£</strong>
            </center>
          <br>`;
        } else {
          document.getElementById("demo").innerHTML = `<div style="border-style: dashed; padding: 5px; border-color: #590202; align-content: center;">
          <h3>Thanks for using Our PS Plus Calc.</h3><br>
          You have <strong>${remainingDays}</strong> days left<br>If you're on the 12 Month Essentials plan and want to
            <center>
            <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromBaseToExtraR}£</strong><br>
            <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromBaseToPremiumR}£</strong>
            </center>
          <br>
          
          If you're on the 3 Month Essentials plan and want to
            <center>
            <strong>👉Upgrade to Extra:</strong> You will pay <strong>${fromQBaseToExtraR}£</strong><br>
            <strong>👉Upgrade to Premium:</strong> You will pay <strong>${fromQBaseToPremiumR}£</strong>
            </center>
          <strong>Please Note that</strong> sales tax isn't included, It depends on your state.</div>`;
        }
      }
        console.log ("Calculations DONE! Say Hello to @callmefarag :) &")
    }
